/*best-practices-for-dependency-installation*/
/*install-dependencies-where-theyre-used*/
/*few-dependencies-in-the-root*/
/*managing-dependencies*/
/*turborepo-does-not-manage-dependencies*/
/*module-resolution-differs-amongst-package-managers*/
/*nodemodules-locations*/
/*keeping-dependencies-on-the-same-version*/
/*using-purpose-built-tooling*/
/*using-your-package-manager*/
/*pnpm-catalogs*/
/*using-an-ide*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "管理依赖",
  "description": "学习如何在 monorepo 的工作区中管理依赖。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "外部依赖来自 npm 注册表，使你能够利用生态系统中的宝贵代码更快地构建应用和库。"
  }, {
    "heading": "",
    "content": "¥External dependencies come from the npm registry, allowing you to leverage valuable code from the ecosystem to build your applications and libraries faster."
  }, {
    "heading": "",
    "content": "内部依赖允许你在存储库内共享功能，从而显著提高共享代码的可发现性和可用性。我们将讨论如何在 下一指南 中构建内部包。"
  }, {
    "heading": "",
    "content": "¥Internal dependencies let you share functionality within your repository, dramatically improving discoverability and usability of shared code. We will discuss how to build an Internal Package in the next guide."
  }, {
    "heading": "依赖安装的最佳实践-best-practices-for-dependency-installation",
    "content": "¥Best practices for dependency installation"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Install dependencies where they're used"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "在存储库中安装依赖时，应将其直接安装在使用它的包中。包的 package.json 将包含包所需的所有依赖。这对于外部和内部依赖都适用。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥When you install a dependency in your repository, you should install it directly in the package that uses it. The package's package.json will have every dependency that the package needs. This is true for both external and internal dependencies."
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "请注意，你的包管理器可以选择 使用与包不同的 node_modules 位置。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Note that your package manager may choose to use a different node_modules\nlocation than the package."
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "要快速安装多个软件包中的依赖，你可以使用软件包管理器："
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥To quickly install dependencies in multiple packages, you can use your package manager:"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "Yarn 1："
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "Yarn 1 文档"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Yarn 1 documentation"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "Yarn 2+："
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "Yarn 2+ 文档"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Yarn 2+ documentation"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "这种做法有几个好处："
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥This practice has several benefits:"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "清晰度提升：当包的依赖在其 package.json 中列出时，更容易理解其依赖。在代码库中工作的开发者可以一目了然地看到包中使用的依赖。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Improved clarity: It's easier to understand what a package depends on when its dependencies are listed in its package.json. Developers working in the repository can see at a glance what dependencies are used within the package."
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "增强的灵活性：在大规模的 monorepo 中，期望每个包使用相同版本的外部依赖是不现实的。当多个团队使用同一代码库时，由于 大规模操作 的实际情况，优先级、时间表和需求会有所不同。通过在依赖的包中安装依赖，你可以让你的 ui 团队升级到最新版本的 TypeScript，而你的 web 团队可以优先发布新功能，并在稍后升级 TypeScript。此外，如果你仍想保持依赖版本同步，请使用 你也可以这样做。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Enhanced flexibility: In a monorepo at scale, it can be unrealistic to expect each package to use the same version of an external dependency. When there are many teams working in the same codebase, there will be differing priorities, timelines, and needs due to the realities of operating at scale. By installing dependencies in the package that uses them, you can enable your ui team to bump to the latest version of TypeScript, while your web team can prioritize shipping new features and bumping TypeScript later. Additionally, if you still want to keep dependency versions in sync, you can do that, too."
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "更好的缓存能力：如果你在仓库根目录中安装了太多依赖，则每次添加、更新或删除依赖时都需要更改工作区根目录，从而导致不必要的缓存未命中。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Better caching ability: If you install too many dependencies in the root of your repository, you'll be changing the workspace root whenever you add, update, or delete a dependency, leading to unnecessary cache misses."
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "修剪未使用的依赖：对于 Docker 用户，Turborepo 的修剪功能 可以从 Docker 镜像中删除未使用的依赖，以创建更轻量的镜像。当依赖安装在其目标包中时，Turborepo 可以读取你的锁定文件并删除你所需包中未使用的依赖。"
  }, {
    "heading": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "¥Pruning unused dependencies: For Docker users, Turborepo's pruning feature can remove unused dependencies from Docker images to create lighter images. When dependencies are installed in the packages that they are meant for, Turborepo can read your lockfile and remove dependencies that aren't used in the packages you need."
  }, {
    "heading": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "¥Few dependencies in the root"
  }, {
    "heading": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "按照上述第一条原则进行 在使用依赖的包中安装依赖 的部署，你会发现工作区根目录中的依赖自然会减少。"
  }, {
    "heading": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "¥Following the first principle above to install dependencies in the package where they're used, you'll find that you naturally end up with few dependencies in the root of your workspace."
  }, {
    "heading": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "工作区根目录中唯一需要的依赖是用于管理存储库的工具，而用于构建应用和库的依赖则安装在各自的包中。一些适合安装在根目录中的依赖示例包括 turbo、husky 或 lint-staged。"
  }, {
    "heading": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "¥The only dependencies that belong in the workspace root are tools for managing the repository whereas dependencies for building applications and libraries are installed in their respective packages. Some examples of dependencies that make sense to install in the root are turbo, husky, or lint-staged."
  }, {
    "heading": "管理依赖-managing-dependencies",
    "content": "¥Managing dependencies"
  }, {
    "heading": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "¥Turborepo does not manage dependencies"
  }, {
    "heading": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "请注意，Turborepo 不负责管理你的依赖，这项工作由你选择的包管理器完成。"
  }, {
    "heading": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "¥Note that Turborepo does not play a role in managing your dependencies, leaving that work up to your package manager of choice."
  }, {
    "heading": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "包管理器负责处理诸如下载正确的外部依赖版本、符号链接和解析模块等任务。本页上的建议是管理工作区中依赖的最佳实践，Turborepo 不强制执行。"
  }, {
    "heading": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "¥It's up to the package manager to handle things like downloading the right external dependency version, symlinking, and resolving modules. The recommendations on this page are best practices for managing dependencies in a Workspace, and are not enforced by Turborepo."
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "¥Module resolution differs amongst package managers"
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "软件包管理器有不同的模块解析算法，这会导致难以预测的行为差异。"
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "¥Package managers have different module resolution algorithms, which leads to differences in behavior that can be difficult to predict."
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "在 Turborepo 文档中，我们根据包管理器的预期行为提出了许多建议。我们尽力介绍了如何处理依赖，你可能需要根据包管理器或仓库的需求调整文档中的行为。"
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "¥In the Turborepo documentation, we make many recommendations according to the expected behaviors of the package managers. Our coverage of how to handle dependencies is best effort and you may need to adapt the documented behavior for your package manager or repository's needs."
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "但是，如果你发现文档中存在问题，该问题似乎对所有包管理器或特定包管理器都普遍不正确，请通过 GitHub Issue 告知我们，以便我们进行改进。"
  }, {
    "heading": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "¥However, if you find an issue with the documentation that appears to be universally incorrect for all package managers or a specific one, please let us know with a GitHub Issue so we can improve."
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "¥node_modules locations"
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "根据你选择的包管理器、版本、设置以及依赖在工作区中的安装位置，你可能会在工作区内的不同位置看到 node_modules 及其内部的依赖。依赖可以在根目录 node_modules 目录、包的 node_modules 目录或两者中找到。"
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "¥Depending on your choice of package manager, version, settings, and where your dependencies are installed in your Workspace, you may see node_modules and the dependencies inside it in various locations within the Workspace. Dependencies could be found in the root node_modules, in packages' node_modules, or both."
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "只要你的脚本和任务能够找到所需的依赖，你的包管理器就能正常工作。"
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "¥As long as your scripts and tasks are able to find the dependencies they need, your package manager is working correctly."
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "工作区中 node_modules 的具体位置不属于包管理器的公共 API。这意味着直接引用 node_modules（如 node ./node_modules/a-package/dist/index.js）可能很脆弱，因为依赖在磁盘上的位置可能会随着工作区周围的其他依赖的变化而变化。"
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "¥The specific locations for node_modules within the Workspace are not a part of the public API of package managers. This means that referencing node_modules directly (like node ./node_modules/a-package/dist/index.js) can be brittle, since the location of the dependency on disk can change with other dependency changes around the Workspace."
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "相反，尽可能依赖 Node.js 生态系统的约定来访问依赖模块。"
  }, {
    "heading": "node_modules-位置-nodemodules-locations",
    "content": "¥Instead, rely on conventions of the Node.js ecosystem for accessing dependency modules whenever possible."
  }, {
    "heading": "保持依赖在同一版本-keeping-dependencies-on-the-same-version",
    "content": "¥Keeping dependencies on the same version"
  }, {
    "heading": "保持依赖在同一版本-keeping-dependencies-on-the-same-version",
    "content": "一些 monorepo 维护者倾向于按照规则在所有软件包中保持对同一版本的依赖。有几种方法可以实现这一点："
  }, {
    "heading": "保持依赖在同一版本-keeping-dependencies-on-the-same-version",
    "content": "¥Some monorepo maintainers prefer to keep dependencies on the same version across all packages by rule. There are several ways to achieve this:"
  }, {
    "heading": "使用专用工具-using-purpose-built-tooling",
    "content": "¥Using purpose-built tooling"
  }, {
    "heading": "使用专用工具-using-purpose-built-tooling",
    "content": "像 syncpack、manypkg 和 sherif 这样的工具可以用于此特定目的。"
  }, {
    "heading": "使用专用工具-using-purpose-built-tooling",
    "content": "¥Tools like syncpack, manypkg, and sherif can be used for this specific purpose."
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "¥Using your package manager"
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "你可以使用软件包管理器在一个命令中更新依赖版本。"
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "¥You can use your package manager to update dependency versions in one command."
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "Yarn 1："
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "Yarn 2+："
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "不支持等效项"
  }, {
    "heading": "使用包管理器-using-your-package-manager",
    "content": "¥No equivalent"
  }, {
    "heading": "pnpm-目录-pnpm-catalogs",
    "content": "¥pnpm catalogs"
  }, {
    "heading": "pnpm-目录-pnpm-catalogs",
    "content": "在 pnpm v9.5+ 中，你可以使用目录将依赖版本范围定义为可重用常量。由于你在整个工作区中引用的是相同的值，因此这将保持依赖在同一版本上。"
  }, {
    "heading": "pnpm-目录-pnpm-catalogs",
    "content": "¥In pnpm v9.5+, you can use catalogs to define dependency version ranges as reusable constants. This will keep dependencies on the same version since you're referencing the same value across the workspace."
  }, {
    "heading": "pnpm-目录-pnpm-catalogs",
    "content": "要了解更多信息，请访问 访问 pnpm 目录文档。"
  }, {
    "heading": "pnpm-目录-pnpm-catalogs",
    "content": "¥To learn more, visit the pnpm catalogs documentation."
  }, {
    "heading": "使用-ide-using-an-ide",
    "content": "¥Using an IDE"
  }, {
    "heading": "使用-ide-using-an-ide",
    "content": "你的 IDE 重构工具可以一次性查找并替换代码库中所有 package.json 文件中依赖的版本。尝试在 package.json 文件上使用类似 \"next\": \".*\" 的正则表达式来查找 next 包的所有实例，并将其替换为所需的版本。完成后，请务必运行包管理器的安装命令来更新锁定文件。"
  }, {
    "heading": "使用-ide-using-an-ide",
    "content": "¥Your IDE's refactoring tooling can find and replace the version of a dependency across all package.json files in your repository at once. Try using a regex like \"next\": \".*\" on package.json files to find all instances of the next package and replace them with the version you want. When you're done, make sure to run your package manager's install command to update your lockfile."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "现在你已经了解了如何在工作区中有效地管理依赖，让我们将 创建内部包 用作 monorepo 中的依赖。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Now that you know how to manage dependencies effectively in a workspace, let's create an Internal Package to be used as a dependency in your monorepo."
  }],
  "headings": [{
    "id": "依赖安装的最佳实践-best-practices-for-dependency-installation",
    "content": "依赖安装的最佳实践 /*best-practices-for-dependency-installation*/"
  }, {
    "id": "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
    "content": "在使用依赖的位置安装它们 /*install-dependencies-where-theyre-used*/"
  }, {
    "id": "根目录中的少量依赖-few-dependencies-in-the-root",
    "content": "根目录中的少量依赖 /*few-dependencies-in-the-root*/"
  }, {
    "id": "管理依赖-managing-dependencies",
    "content": "管理依赖 /*managing-dependencies*/"
  }, {
    "id": "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
    "content": "Turborepo 不管理依赖 /*turborepo-does-not-manage-dependencies*/"
  }, {
    "id": "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
    "content": "不同包管理器的模块解析不同 /*module-resolution-differs-amongst-package-managers*/"
  }, {
    "id": "node_modules-位置-nodemodules-locations",
    "content": "node_modules 位置 /*nodemodules-locations*/"
  }, {
    "id": "保持依赖在同一版本-keeping-dependencies-on-the-same-version",
    "content": "保持依赖在同一版本 /*keeping-dependencies-on-the-same-version*/"
  }, {
    "id": "使用专用工具-using-purpose-built-tooling",
    "content": "使用专用工具 /*using-purpose-built-tooling*/"
  }, {
    "id": "使用包管理器-using-your-package-manager",
    "content": "使用包管理器 /*using-your-package-manager*/"
  }, {
    "id": "pnpm-目录-pnpm-catalogs",
    "content": "pnpm 目录 /*pnpm-catalogs*/"
  }, {
    "id": "使用-ide-using-an-ide",
    "content": "使用 IDE /*using-an-ide*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#依赖安装的最佳实践-best-practices-for-dependency-installation",
  title: _jsx(_Fragment, {
    children: "依赖安装的最佳实践 "
  })
}, {
  depth: 3,
  url: "#在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
  title: _jsx(_Fragment, {
    children: "在使用依赖的位置安装它们 "
  })
}, {
  depth: 3,
  url: "#根目录中的少量依赖-few-dependencies-in-the-root",
  title: _jsx(_Fragment, {
    children: "根目录中的少量依赖 "
  })
}, {
  depth: 2,
  url: "#管理依赖-managing-dependencies",
  title: _jsx(_Fragment, {
    children: "管理依赖 "
  })
}, {
  depth: 3,
  url: "#turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
  title: _jsx(_Fragment, {
    children: "Turborepo 不管理依赖 "
  })
}, {
  depth: 3,
  url: "#不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
  title: _jsx(_Fragment, {
    children: "不同包管理器的模块解析不同 "
  })
}, {
  depth: 3,
  url: "#node_modules-位置-nodemodules-locations",
  title: _jsx(_Fragment, {
    children: "node_modules 位置 "
  })
}, {
  depth: 3,
  url: "#保持依赖在同一版本-keeping-dependencies-on-the-same-version",
  title: _jsx(_Fragment, {
    children: "保持依赖在同一版本 "
  })
}, {
  depth: 4,
  url: "#使用专用工具-using-purpose-built-tooling",
  title: _jsx(_Fragment, {
    children: "使用专用工具 "
  })
}, {
  depth: 4,
  url: "#使用包管理器-using-your-package-manager",
  title: _jsx(_Fragment, {
    children: "使用包管理器 "
  })
}, {
  depth: 4,
  url: "#pnpm-目录-pnpm-catalogs",
  title: _jsx(_Fragment, {
    children: "pnpm 目录 "
  })
}, {
  depth: 4,
  url: "#使用-ide-using-an-ide",
  title: _jsx(_Fragment, {
    children: "使用 IDE "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["外部依赖来自 ", _jsx(_components.a, {
            href: "https://www.npmjs.com/",
            children: "npm 注册表"
          }), "，使你能够利用生态系统中的宝贵代码更快地构建应用和库。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "External dependencies"
          }), " come from ", _jsx(_components.a, {
            href: "https://www.npmjs.com/",
            children: "the npm registry"
          }), ", allowing you to leverage valuable code from the ecosystem to build your applications and libraries faster."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["内部依赖允许你在存储库内共享功能，从而显著提高共享代码的可发现性和可用性。我们将讨论如何在 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/creating-an-internal-package",
            children: "下一指南"
          }), " 中构建内部包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Internal dependencies"
          }), " let you share functionality within your repository, dramatically improving discoverability and usability of shared code. We will discuss how to build an Internal Package in ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/creating-an-internal-package",
            children: "the next guide"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // External dependency"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // Internal dependency"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // External dependency"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // Internal dependency"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // External dependency"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // Internal dependency"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // External dependency"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // Internal dependency"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "依赖安装的最佳实践-best-practices-for-dependency-installation",
      children: "依赖安装的最佳实践 "
    }), "\n", _jsx(_components.p, {
      children: "¥Best practices for dependency installation"
    }), "\n", _jsx(_components.h3, {
      id: "在使用依赖的位置安装它们-install-dependencies-where-theyre-used",
      children: "在使用依赖的位置安装它们 "
    }), "\n", _jsx(_components.p, {
      children: "¥Install dependencies where they're used"
    }), "\n", _jsxs(_components.p, {
      children: ["在存储库中安装依赖时，应将其直接安装在使用它的包中。包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 将包含包所需的所有依赖。这对于外部和内部依赖都适用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you install a dependency in your repository, you should install it directly in the package that uses it. The package's ", _jsx(_components.code, {
        children: "package.json"
      }), " will have every dependency that the package needs. This is true for both external and internal dependencies."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["请注意，你的包管理器可以选择 ", _jsx(_components.a, {
          href: "#node_modules-locations",
          children: "使用与包不同的 node_modules 位置"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥Note that your package manager may choose to ", _jsx(_components.a, {
          href: "#node_modules-locations",
          children: "use a different node_modules\nlocation than the package"
        }), "."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "要快速安装多个软件包中的依赖，你可以使用软件包管理器："
    }), "\n", _jsx(_components.p, {
      children: "¥To quickly install dependencies in multiple packages, you can use your package manager:"
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsxs(Tab, {
        value: "pnpm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --recursive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=@repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=docs"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://pnpm.nodejs.cn/cli/recursive",
          children: "pnpm documentation"
        })]
      }), _jsxs(Tab, {
        value: "yarn",
        children: [_jsx(_components.p, {
          children: "Yarn 1："
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspace"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspace"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })]
            })
          })
        }), _jsxs(LinkToDocumentation, {
          href: "https://yarn.nodejs.cn/en/docs/cli/add",
          children: [_jsx(_components.p, {
            children: "Yarn 1 文档"
          }), _jsx(_components.p, {
            children: "¥Yarn 1 documentation"
          })]
        }), _jsx(_components.p, {
          children: "Yarn 2+："
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspaces"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " foreach"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -R"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '{web,@repo/ui}'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        }), _jsxs(LinkToDocumentation, {
          href: "https://yarn.nodejs.cn/cli/workspaces/foreach#usage",
          children: [_jsx(_components.p, {
            children: "Yarn 2+ 文档"
          }), _jsx(_components.p, {
            children: "¥Yarn 2+ documentation"
          })]
        })]
      }), _jsxs(Tab, {
        value: "npm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspace=web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspace=@repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://npm.nodejs.cn/cli/v7/using-npm/config#workspace",
          children: "npm documentation"
        })]
      }), _jsxs(Tab, {
        value: "bun",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "cd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: " &&"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "cd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " packages/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: " &&"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })]
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://bun.sh/docs/install/workspaces",
          children: "bun documentation"
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "这种做法有几个好处："
    }), "\n", _jsx(_components.p, {
      children: "¥This practice has several benefits:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["清晰度提升：当包的依赖在其 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中列出时，更容易理解其依赖。在代码库中工作的开发者可以一目了然地看到包中使用的依赖。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Improved clarity"
          }), ": It's easier to understand what a package depends on when its dependencies are listed in its ", _jsx(_components.code, {
            children: "package.json"
          }), ". Developers working in the repository can see at a glance what dependencies are used within the package."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["增强的灵活性：在大规模的 monorepo 中，期望每个包使用相同版本的外部依赖是不现实的。当多个团队使用同一代码库时，由于 ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-to-scale-a-large-codebase",
            children: "大规模操作"
          }), " 的实际情况，优先级、时间表和需求会有所不同。通过在依赖的包中安装依赖，你可以让你的 ", _jsx(_components.code, {
            children: "ui"
          }), " 团队升级到最新版本的 TypeScript，而你的 ", _jsx(_components.code, {
            children: "web"
          }), " 团队可以优先发布新功能，并在稍后升级 TypeScript。此外，如果你仍想保持依赖版本同步，请使用 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/managing-dependencies#keeping-dependencies-on-the-same-version",
            children: "你也可以这样做"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Enhanced flexibility"
          }), ": In a monorepo at scale, it can be unrealistic to expect each package to use the same version of an external dependency. When there are many teams working in the same codebase, there will be differing priorities, timelines, and needs due to the realities of ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-to-scale-a-large-codebase",
            children: "operating at scale"
          }), ". By installing dependencies in the package that uses them, you can enable your ", _jsx(_components.code, {
            children: "ui"
          }), " team to bump to the latest version of TypeScript, while your ", _jsx(_components.code, {
            children: "web"
          }), " team can prioritize shipping new features and bumping TypeScript later. Additionally, if you still want to keep dependency versions in sync, ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/managing-dependencies#keeping-dependencies-on-the-same-version",
            children: "you can do that, too"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "更好的缓存能力：如果你在仓库根目录中安装了太多依赖，则每次添加、更新或删除依赖时都需要更改工作区根目录，从而导致不必要的缓存未命中。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Better caching ability"
          }), ": If you install too many dependencies in the root of your repository, you'll be changing the workspace root whenever you add, update, or delete a dependency, leading to unnecessary cache misses."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["修剪未使用的依赖：对于 Docker 用户，", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "Turborepo 的修剪功能"
          }), " 可以从 Docker 镜像中删除未使用的依赖，以创建更轻量的镜像。当依赖安装在其目标包中时，Turborepo 可以读取你的锁定文件并删除你所需包中未使用的依赖。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Pruning unused dependencies"
          }), ": For Docker users, ", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "Turborepo's pruning feature"
          }), " can remove unused dependencies from Docker images to create lighter images. When dependencies are installed in the packages that they are meant for, Turborepo can read your lockfile and remove dependencies that aren't used in the packages you need."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "根目录中的少量依赖-few-dependencies-in-the-root",
      children: "根目录中的少量依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Few dependencies in the root"
    }), "\n", _jsxs(_components.p, {
      children: ["按照上述第一条原则进行 ", _jsx(_components.a, {
        href: "#install-dependencies-where-theyre-used",
        children: "在使用依赖的包中安装依赖"
      }), " 的部署，你会发现工作区根目录中的依赖自然会减少。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Following the first principle above to ", _jsx(_components.a, {
        href: "#install-dependencies-where-theyre-used",
        children: "install dependencies in the package where they're used"
      }), ", you'll find that you naturally end up with few dependencies in the root of your workspace."]
    }), "\n", _jsxs(_components.p, {
      children: ["工作区根目录中唯一需要的依赖是用于管理存储库的工具，而用于构建应用和库的依赖则安装在各自的包中。一些适合安装在根目录中的依赖示例包括 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/turbo",
        children: _jsx(_components.code, {
          children: "turbo"
        })
      }), "、", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/husky",
        children: _jsx(_components.code, {
          children: "husky"
        })
      }), " 或 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/lint-staged",
        children: _jsx(_components.code, {
          children: "lint-staged"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The only dependencies that belong in the workspace root are ", _jsx(_components.strong, {
        children: "tools for managing the repository"
      }), " whereas dependencies for building applications and libraries are installed in their respective packages. Some examples of dependencies that make sense to install in the root are ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/turbo",
        children: _jsx(_components.code, {
          children: "turbo"
        })
      }), ", ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/husky",
        children: _jsx(_components.code, {
          children: "husky"
        })
      }), ", or ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/lint-staged",
        children: _jsx(_components.code, {
          children: "lint-staged"
        })
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "管理依赖-managing-dependencies",
      children: "管理依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Managing dependencies"
    }), "\n", _jsx(_components.h3, {
      id: "turborepo-不管理依赖-turborepo-does-not-manage-dependencies",
      children: "Turborepo 不管理依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo does not manage dependencies"
    }), "\n", _jsx(_components.p, {
      children: "请注意，Turborepo 不负责管理你的依赖，这项工作由你选择的包管理器完成。"
    }), "\n", _jsx(_components.p, {
      children: "¥Note that Turborepo does not play a role in managing your dependencies, leaving that work up to your package manager of choice."
    }), "\n", _jsx(_components.p, {
      children: "包管理器负责处理诸如下载正确的外部依赖版本、符号链接和解析模块等任务。本页上的建议是管理工作区中依赖的最佳实践，Turborepo 不强制执行。"
    }), "\n", _jsx(_components.p, {
      children: "¥It's up to the package manager to handle things like downloading the right external dependency version, symlinking, and resolving modules. The recommendations on this page are best practices for managing dependencies in a Workspace, and are not enforced by Turborepo."
    }), "\n", _jsx(_components.h3, {
      id: "不同包管理器的模块解析不同-module-resolution-differs-amongst-package-managers",
      children: "不同包管理器的模块解析不同 "
    }), "\n", _jsx(_components.p, {
      children: "¥Module resolution differs amongst package managers"
    }), "\n", _jsx(_components.p, {
      children: "软件包管理器有不同的模块解析算法，这会导致难以预测的行为差异。"
    }), "\n", _jsx(_components.p, {
      children: "¥Package managers have different module resolution algorithms, which leads to differences in behavior that can be difficult to predict."
    }), "\n", _jsx(_components.p, {
      children: "在 Turborepo 文档中，我们根据包管理器的预期行为提出了许多建议。我们尽力介绍了如何处理依赖，你可能需要根据包管理器或仓库的需求调整文档中的行为。"
    }), "\n", _jsx(_components.p, {
      children: "¥In the Turborepo documentation, we make many recommendations according to the expected behaviors of the package managers. Our coverage of how to handle dependencies is best effort and you may need to adapt the documented behavior for your package manager or repository's needs."
    }), "\n", _jsx(_components.p, {
      children: "但是，如果你发现文档中存在问题，该问题似乎对所有包管理器或特定包管理器都普遍不正确，请通过 GitHub Issue 告知我们，以便我们进行改进。"
    }), "\n", _jsx(_components.p, {
      children: "¥However, if you find an issue with the documentation that appears to be universally incorrect for all package managers or a specific one, please let us know with a GitHub Issue so we can improve."
    }), "\n", _jsx(_components.h3, {
      id: "node_modules-位置-nodemodules-locations",
      children: "node_modules 位置 "
    }), "\n", _jsx(_components.p, {
      children: "¥node_modules locations"
    }), "\n", _jsxs(_components.p, {
      children: ["根据你选择的包管理器、版本、设置以及依赖在工作区中的安装位置，你可能会在工作区内的不同位置看到 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 及其内部的依赖。依赖可以在根目录 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 目录、包的 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 目录或两者中找到。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Depending on your choice of package manager, version, settings, and where your dependencies are installed in your Workspace, you may see ", _jsx(_components.code, {
        children: "node_modules"
      }), " and the dependencies inside it in various locations within the Workspace. Dependencies could be found in the root ", _jsx(_components.code, {
        children: "node_modules"
      }), ", in packages' ", _jsx(_components.code, {
        children: "node_modules"
      }), ", or both."]
    }), "\n", _jsx(_components.p, {
      children: "只要你的脚本和任务能够找到所需的依赖，你的包管理器就能正常工作。"
    }), "\n", _jsx(_components.p, {
      children: "¥As long as your scripts and tasks are able to find the dependencies they need, your package manager is working correctly."
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Referencing `node_modules` in your code",
      children: [_jsxs(_components.p, {
        children: ["工作区中 ", _jsx(_components.code, {
          children: "node_modules"
        }), " 的具体位置不属于包管理器的公共 API。这意味着直接引用 ", _jsx(_components.code, {
          children: "node_modules"
        }), "（如 ", _jsx(_components.code, {
          children: "node ./node_modules/a-package/dist/index.js"
        }), "）可能很脆弱，因为依赖在磁盘上的位置可能会随着工作区周围的其他依赖的变化而变化。"]
      }), _jsxs(_components.p, {
        children: ["¥The specific locations for ", _jsx(_components.code, {
          children: "node_modules"
        }), " within the Workspace are not a part of the public API of package managers. This means that referencing ", _jsx(_components.code, {
          children: "node_modules"
        }), " directly (like ", _jsx(_components.code, {
          children: "node ./node_modules/a-package/dist/index.js"
        }), ") can be brittle, since the location of the dependency on disk can change with other dependency changes around the Workspace."]
      }), _jsx(_components.p, {
        children: "相反，尽可能依赖 Node.js 生态系统的约定来访问依赖模块。"
      }), _jsx(_components.p, {
        children: "¥Instead, rely on conventions of the Node.js ecosystem for accessing dependency modules whenever possible."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "保持依赖在同一版本-keeping-dependencies-on-the-same-version",
      children: "保持依赖在同一版本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Keeping dependencies on the same version"
    }), "\n", _jsx(_components.p, {
      children: "一些 monorepo 维护者倾向于按照规则在所有软件包中保持对同一版本的依赖。有几种方法可以实现这一点："
    }), "\n", _jsx(_components.p, {
      children: "¥Some monorepo maintainers prefer to keep dependencies on the same version across all packages by rule. There are several ways to achieve this:"
    }), "\n", _jsx(_components.h4, {
      id: "使用专用工具-using-purpose-built-tooling",
      children: "使用专用工具 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using purpose-built tooling"
    }), "\n", _jsxs(_components.p, {
      children: ["像 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/syncpack",
        children: _jsx(_components.code, {
          children: "syncpack"
        })
      }), "、", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@manypkg/cli",
        children: _jsx(_components.code, {
          children: "manypkg"
        })
      }), " 和 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/sherif",
        children: _jsx(_components.code, {
          children: "sherif"
        })
      }), " 这样的工具可以用于此特定目的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Tools like ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/syncpack",
        children: _jsx(_components.code, {
          children: "syncpack"
        })
      }), ", ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@manypkg/cli",
        children: _jsx(_components.code, {
          children: "manypkg"
        })
      }), ", and ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/sherif",
        children: _jsx(_components.code, {
          children: "sherif"
        })
      }), " can be used for this specific purpose."]
    }), "\n", _jsx(_components.h4, {
      id: "使用包管理器-using-your-package-manager",
      children: "使用包管理器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using your package manager"
    }), "\n", _jsx(_components.p, {
      children: "你可以使用软件包管理器在一个命令中更新依赖版本。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can use your package manager to update dependency versions in one command."
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsxs(Tab, {
        value: "pnpm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " up"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --recursive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://pnpm.nodejs.cn/cli/update#--recursive--r",
            children: "→ pnpm documentation"
          })
        })]
      }), _jsxs(Tab, {
        value: "yarn",
        children: [_jsx(_components.p, {
          children: "Yarn 1："
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " upgrade-interactive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --latest"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://yarn.nodejs.cn/en/docs/cli/upgrade-interactive",
            children: "→ Yarn 1 documentation"
          })
        }), _jsx(_components.p, {
          children: "Yarn 2+："
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " upgrade"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --upgrade"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://yarn.nodejs.cn/cli/up",
            children: "→ Yarn 2+ documentation"
          })
        })]
      }), _jsxs(Tab, {
        value: "npm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspaces"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://npm.nodejs.cn/cli/v7/using-npm/config#workspaces",
            children: "→ npm documentation"
          })
        })]
      }), _jsxs(Tab, {
        value: "bun",
        children: [_jsx(_components.p, {
          children: "不支持等效项"
        }), _jsx(_components.p, {
          children: "¥No equivalent"
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://bun.sh/docs/install/workspaces",
            children: "→ Bun documentation"
          })
        })]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "pnpm-目录-pnpm-catalogs",
      children: "pnpm 目录 "
    }), "\n", _jsx(_components.p, {
      children: "¥pnpm catalogs"
    }), "\n", _jsx(_components.p, {
      children: "在 pnpm v9.5+ 中，你可以使用目录将依赖版本范围定义为可重用常量。由于你在整个工作区中引用的是相同的值，因此这将保持依赖在同一版本上。"
    }), "\n", _jsx(_components.p, {
      children: "¥In pnpm v9.5+, you can use catalogs to define dependency version ranges as reusable constants. This will keep dependencies on the same version since you're referencing the same value across the workspace."
    }), "\n", _jsxs(_components.p, {
      children: ["要了解更多信息，请访问 ", _jsx(_components.a, {
        href: "https://pnpm.nodejs.cn/catalogs",
        children: "访问 pnpm 目录文档"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To learn more, ", _jsx(_components.a, {
        href: "https://pnpm.nodejs.cn/catalogs",
        children: "visit the pnpm catalogs documentation"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "使用-ide-using-an-ide",
      children: "使用 IDE "
    }), "\n", _jsx(_components.p, {
      children: "¥Using an IDE"
    }), "\n", _jsxs(_components.p, {
      children: ["你的 IDE 重构工具可以一次性查找并替换代码库中所有 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件中依赖的版本。尝试在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件上使用类似 ", _jsx(_components.code, {
        children: "\"next\": \".*\""
      }), " 的正则表达式来查找 ", _jsx(_components.code, {
        children: "next"
      }), " 包的所有实例，并将其替换为所需的版本。完成后，请务必运行包管理器的安装命令来更新锁定文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Your IDE's refactoring tooling can find and replace the version of a dependency across all ", _jsx(_components.code, {
        children: "package.json"
      }), " files in your repository at once. Try using a regex like ", _jsx(_components.code, {
        children: "\"next\": \".*\""
      }), " on ", _jsx(_components.code, {
        children: "package.json"
      }), " files to find all instances of the ", _jsx(_components.code, {
        children: "next"
      }), " package and replace them with the version you want. When you're done, make sure to run your package manager's install command to update your lockfile."]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["现在你已经了解了如何在工作区中有效地管理依赖，让我们将 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "创建内部包"
      }), " 用作 monorepo 中的依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now that you know how to manage dependencies effectively in a workspace, let's ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "create an Internal Package"
      }), " to be used as a dependency in your monorepo."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
